export const presentationV4 = {
	en: {
		titles: {
			modal_title: "New Trackme version - Coming Soon!",
			btn_explorer: "Go to v4",
			btn_close: "Close",
		},
		animated_banner: {
			isEnglish: true,
			title_1: `Everything you already have in the version 3.0`,
			title_2: `but <span class="text-yellow">improved in this new one</span>`,
      title_list: "New features",
      text_btn: "Try now the new version 4.0",
			link: "https://gstrackme.net/v4/login?lang=en",
      list: [
        'Improvements in the <span class="text-yellow">camera modules</span>',
        'Redesign of the <span class="text-yellow">history report</span>',
        'Alerts <span class="text-yellow">100% customizable and configurable</span> as you need',
      ]
		},
		banners: [
			{
				alt: "realtime",
				img: "v4/v4-realtime-en.png",
				title: "New Real-time Interface",
				text: `<p>
          Discover the latest version of TRACKME, now with a completely revamped interface for an even 
          more intuitive and user-friendly experience. Monitor vehicle statuses and sensors in real time 
          with enhanced visualizations, allowing you to filter by status and instantly access up-to-the-minute 
          statistics—all in real time!
        </p>`,
			},
			{
				alt: "history",
				img: "v4/v4-history-en.png",
				title: "Revamped Route History!",
				text: `<p> 
          Explore your device history like never before with our new video-like playback feature.
          Easily view routes as if you're watching a video, with the ability to fast-forward, rewind, 
          or zoom in on specific segments of the journey, giving you full control over your data.
        </p>`,
			},
			{
				alt: "cameras",
				img: "v4/v4-cameras-en.png",
				title: "Completely Redesigned Camera Section!",
				text: `<p>
          In the camera section, use the integrated calendar to view specific days with captured videos. 
          Select precise times down to the minute, complete with synchronized snapshots and events aligned 
          with the vehicle's route on the map, for a more comprehensive and detailed review of each trip. 
        </p>`,
			},
			{
				alt: "album",
				img: "v4/v4-album-en.png",
				title: "Camera Snapshot/Clip Album!",
				text: `<p>
          Additionally, AI-powered cameras now allow you to view captured photos directly on the platform, 
          neatly organized by camera and date. 
          Plus, you can access previously downloaded videos for seamless video management.
        </p>`,
			},
		],
	},
	es: {
		titles: {
			modal_title: "Descubre la nueva versión de TRACKME",
			btn_explorer: "Explorar v4",
			btn_close: "Cerrar",
		},
    animated_banner: {
			isEnglish: false,
			title_1: `Todo lo que ya tienes en la versión 3.0`,
			title_2: 'pero <span class="text-yellow">mejorado en esta nueva</span>',
      title_list: "Nuevas características",
      text_btn: "Prueba ahora la nueva versión 4.0",
			link: "https://gstrackme.mx/login?lang=es",
      list: [
        'Mejora del <span class="text-yellow">módulo de cámaras</span>',
        'Rediseño del <span class="text-yellow">reporte de histórico</span>',
        'Alertas <span class="text-yellow">100% personalizable y configurable</span> como tú necesites',
      ]
		},
		banners: [
			{
				alt: "presentation",
				img: "animation-v4-webinar.png",
				title: "",
				classBanner: "classWebinar",
				text: `<p style="font-size: 0.93rem;">
          ¡La nueva versión de la plataforma TRACKME está a punto de llegar! Con una interfaz completamente rediseñada, 
          hemos hecho mejoras significativas para brindarte una experiencia más intuitiva y eficiente. Además de las nuevas 
          funcionalidades sorprendentes, ahora podrás navegar de manera más fluida, acceder a informes en tiempo real y 
          disfrutar de herramientas avanzadas de monitoreo y análisis. Todo esto con el objetivo de facilitar tu gestión y optimizar 
          el seguimiento de tus dispositivos como nunca antes.
        </p>`,
			},
			{
				alt: "realtime",
				img: "v4/v4-realtime-es.png",
				title: "!!Nueva interfaz para el realtime!!",
				text: `<p> Descubre la nueva versión de TRACKME, con una interfaz completamente renovada. 
          Disfruta de visualizaciones más intuitivas y fáciles de usar, donde, en <b>tiempo real</b>, 
          podrás monitorear el estado de los vehículos y sus sensores. Además, filtra por estatus y accede a 
          estadísticas actualizadas al instante. ¡Todo en tiempo real! 
        </p>`,
			},
			{
				alt: "history",
				img: "v4/v4-history-es.png",
				title: "¡¡Historial como si fuera un video!!",
				text: `<p> Explora el histórico de tus dispositivos como si estuvieras viendo un video. Ahora puedes 
          visualizar sus recorridos de manera sorprendente, con la posibilidad de avanzar o retroceder en el
          tiempo <b>como si fuera un reproductor de video</b>. ¡Incluso puedes visualizar segmentos específicos
          del recorrido según lo prefieras! 
        </p>`,
			},
			{
				alt: "cameras",
				img: "v4/v4-cameras-es.png",
				title: "¡¡Descarga los videos de las cámaras!!",
				text: `<p>
          Ahora, en la sección de cámaras, puedes visualizar en el calendario los días en los que hay videos capturados. 
          Selecciona la hora y el minuto que desees, junto con las capturas y eventos registrados, sincronizados con 
          el recorrido del vehículo en el mapa, para una experiencia más completa y detallada. 
        </p>`,
			},
			{
				alt: "album",
				img: "v4/v4-album-es.png",
				title: "¡¡Mira las fotos capturadas por las cámaras!!",
				text: `<p>
          Ahora, las cámaras con <b>IA</b> que capturan fotos se pueden visualizar dentro de la plataforma, 
          organizadas en carpetas por cámara y fecha. Además, podrás acceder a los videos descargados previamente.
        </p>`,
			},
		],
	},
};
